(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ov-account-support-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function writeText(text, onSuccess, onFailure) {
      function fallbackCopy() {
        var textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.top = '-9999px';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();

        try {
          if (document.execCommand('copy')) {
            onSuccess();
          } else {
            onFailure();
          }
        } catch (error) {
          onFailure();
        }

        document.body.removeChild(textarea);
      }

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(onSuccess).catch(fallbackCopy);
        return;
      }

      fallbackCopy();
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-ov-copy-account-support-packet], [data-ov-copy-account-old-coupon-packet]');
      if (!button) return;

      var targetId = button.getAttribute('data-ov-copy-target');
      var template = document.getElementById(targetId);
      var container = button.closest('.ov-account-support__packet, .ov-account-support__old-coupon');
      var status = container ? container.querySelector('[data-ov-copy-account-support-status], [data-ov-copy-account-old-coupon-status]') : null;
      var successText = button.getAttribute('data-ov-copy-success') || 'Copied';
      var errorText = button.getAttribute('data-ov-copy-error') || 'Copy manually';
      var text = '';

      if (template && template.content) {
        text = template.content.textContent;
      } else if (template) {
        text = template.textContent;
      }

      text = text.trim();
      if (!text) return;

      writeText(text, function () {
        if (status) status.textContent = successText;
      }, function () {
        if (status) status.textContent = errorText;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ov-affiliate-page"] && !Shopify.designMode) return;
  try {
    
  function ovAffiliateWriteClipboardText(text, onSuccess, onFailure) {
    function fallbackCopy() {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.top = '-9999px';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();

      try {
        if (document.execCommand('copy')) {
          onSuccess();
        } else {
          onFailure();
        }
      } catch (error) {
        onFailure();
      }

      document.body.removeChild(textarea);
    }

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(onSuccess).catch(fallbackCopy);
      return;
    }

    fallbackCopy();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ov-copy]');
    if (!button) return;
    var input = document.getElementById(button.getAttribute('data-ov-copy'));
    if (!input) return;
    input.select();
    input.setSelectionRange(0, input.value.length);
    ovAffiliateWriteClipboardText(input.value, function () {
      button.textContent = 'Copied';
      window.setTimeout(function () {
        button.textContent = 'Copy';
      }, 1600);
    }, function () {
      button.textContent = 'Copy manually';
      window.setTimeout(function () {
        button.textContent = 'Copy';
      }, 2000);
    });
  });

  document.addEventListener('click', function (event) {
    var packetButton = event.target.closest('[data-ov-copy-affiliate-packet], [data-ov-copy-affiliate-monthly-packet]');
    if (!packetButton) return;

    var targetId = packetButton.getAttribute('data-ov-copy-target');
    var template = document.getElementById(targetId);
    var packetContainer = packetButton.closest('.ov-affiliate-page__application-packet, .ov-affiliate-page__partner-standard');
    var status = packetContainer ? packetContainer.querySelector('[data-ov-copy-affiliate-status], [data-ov-copy-affiliate-monthly-status]') : document.querySelector('[data-ov-copy-affiliate-status]');
    var successText = packetButton.getAttribute('data-ov-copy-success') || 'Copied';
    var errorText = packetButton.getAttribute('data-ov-copy-error') || 'Copy manually';
    var text = '';

    if (template && template.content) {
      text = template.content.textContent;
    } else if (template) {
      text = template.textContent;
    }

    text = text.trim();
    if (!text) return;

    ovAffiliateWriteClipboardText(text, function () {
      if (status) status.textContent = successText;
    }, function () {
      if (status) status.textContent = errorText;
    });
  });

  (function () {
    var dashboard = document.querySelector('[data-ov-affiliate-dashboard]');
    if (!dashboard) return;

    var proxyUrl = dashboard.getAttribute('data-ov-affiliate-proxy');
    var status = dashboard.querySelector('[data-ov-affiliate-status]');
    var ordersContainer = dashboard.querySelector('[data-ov-affiliate-orders]');

    function setStatus(message) {
      if (status) status.textContent = message;
    }

    function setMetric(name, value) {
      var target = dashboard.querySelector('[data-ov-affiliate-metric="' + name + '"]');
      if (target) target.textContent = value;
    }

    function renderOrders(orders) {
      if (!ordersContainer) return;
      ordersContainer.innerHTML = '';

      if (!orders || !orders.length) {
        ordersContainer.hidden = false;
        ordersContainer.innerHTML = '<p>No referred orders found yet.</p>';
        return;
      }

      ordersContainer.hidden = false;
      orders.slice(0, 8).forEach(function (order) {
        var row = document.createElement('div');
        row.className = 'ov-affiliate-page__order-row';
        row.innerHTML =
          '<strong></strong><span></span><span></span>';
        row.children[0].textContent = order.name || 'Order';
        row.children[1].textContent =
          (order.financialStatus || 'Pending') + ' / ' + (order.fulfillmentStatus || 'Unfulfilled');
        row.children[2].textContent = order.totalDisplay || '';
        ordersContainer.appendChild(row);
      });
    }

    fetch(proxyUrl, {
      credentials: 'same-origin',
      headers: {
        accept: 'application/json',
      },
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok) {
            throw new Error(payload.message || 'Partner data unavailable');
          }
          return payload;
        });
      })
      .then(function (payload) {
        var performance = payload.performance || {};
        setMetric('orderCount', performance.orderCount || 0);
        setMetric('paidOrderCount', performance.paidOrderCount || 0);
        setMetric('eligibleRevenueDisplay', performance.eligibleRevenueDisplay || '$0.00');
        setMetric('estimatedCommissionDisplay', performance.estimatedCommissionDisplay || '$0.00');
        renderOrders(performance.orders || []);

        if (payload.lastSyncedAt) {
          setStatus('Partner performance refreshed ' + new Date(payload.lastSyncedAt).toLocaleString());
        } else {
          setStatus('Partner performance loaded');
        }
      })
      .catch(function () {
        setMetric('orderCount', 'Preparing');
        setMetric('paidOrderCount', 'Preparing');
        setMetric('eligibleRevenueDisplay', 'Preparing');
        setMetric('estimatedCommissionDisplay', 'Preparing');
        setStatus('Partner performance is being prepared. Your approved code and referral link remain available.');
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ov-customer-account"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-ov-copy-packet], [data-ov-copy-old-coupon-packet], [data-ov-copy-order-card-packet], [data-ov-copy-affiliate-account-packet]');
    if (!button) {
      return;
    }

    var targetId = button.getAttribute('data-copy-target');
    var target = targetId ? document.getElementById(targetId) : null;
    var container = button.closest('.ov-account-support-packet, .ov-account-old-coupon-packet, .ov-account-order-card, .ov-account-panel--affiliate');
    var status = container ? container.querySelector('[data-ov-copy-status], [data-ov-copy-old-coupon-status], [data-ov-copy-order-card-status], [data-ov-copy-affiliate-status]') : null;
    var text = target ? target.textContent.trim() : '';

    if (!text) {
      return;
    }

    var defaultText = button.textContent.trim();
    var successText = button.getAttribute('data-copy-success') || defaultText;
    var errorText = button.getAttribute('data-copy-error') || defaultText;

    var showStatus = function(message) {
      if (status) {
        status.textContent = message;
      }
      button.textContent = message;
      window.setTimeout(function() {
        button.textContent = defaultText;
      }, 2200);
    };

    var fallbackCopy = function() {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.top = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        var copied = document.execCommand('copy');
        showStatus(copied ? successText : errorText);
      } catch (error) {
        showStatus(errorText);
      }

      document.body.removeChild(textarea);
    };

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(function() {
        showStatus(successText);
      }).catch(function() {
        fallbackCopy();
      });
    } else {
      fallbackCopy();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ov-customer-addresses"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function optionMatches(option, value) {
      return option.value === value || option.textContent === value;
    }

    function applyDefault(select) {
      var defaultValue = select.getAttribute('data-default');
      if (!defaultValue) return;
      Array.prototype.forEach.call(select.options, function (option) {
        if (optionMatches(option, defaultValue)) {
          option.selected = true;
        }
      });
    }

    function renderProvinces(countrySelect) {
      var provinceSelect = document.getElementById(countrySelect.getAttribute('data-ov-province-target'));
      if (!provinceSelect) return;
      var selected = countrySelect.options[countrySelect.selectedIndex];
      var provinceDefault = provinceSelect.getAttribute('data-default');
      var provinces = [];

      try {
        provinces = JSON.parse(selected.getAttribute('data-provinces') || '[]');
      } catch (error) {
        provinces = [];
      }

      provinceSelect.innerHTML = '';

      if (!provinces.length) {
        provinceSelect.disabled = true;
        provinceSelect.removeAttribute('required');
        return;
      }

      provinceSelect.disabled = false;
      provinceSelect.setAttribute('required', 'required');

      provinces.forEach(function (province) {
        var option = document.createElement('option');
        option.value = province[0];
        option.textContent = province[1] || province[0];
        if (provinceDefault && optionMatches(option, provinceDefault)) {
          option.selected = true;
        }
        provinceSelect.appendChild(option);
      });
    }

    document.querySelectorAll('[data-ov-address-country]').forEach(function (countrySelect) {
      applyDefault(countrySelect);
      renderProvinces(countrySelect);
      countrySelect.addEventListener('change', function () {
        renderProvinces(countrySelect);
      });
    });

    document.querySelectorAll('[data-ov-address-delete]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        var message = form.getAttribute('data-confirm-message');
        if (message && !window.confirm(message)) {
          event.preventDefault();
        }
      });
    });

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-ov-copy-delivery-packet], [data-ov-copy-address-profile]');
      if (!button) return;

      var targetId = button.getAttribute('data-copy-target');
      var target = targetId ? document.getElementById(targetId) : null;
      var container = button.closest('.ov-customer-addresses__support-packet, .ov-customer-addresses__card');
      var status = container ? container.querySelector('[data-ov-copy-delivery-status], [data-ov-copy-address-profile-status]') : null;
      var text = target ? target.textContent.trim() : '';

      if (!text) return;

      var defaultText = button.textContent.trim();
      var successText = button.getAttribute('data-copy-success') || defaultText;
      var errorText = button.getAttribute('data-copy-error') || defaultText;

      function showStatus(message) {
        if (status) {
          status.textContent = message;
        }
        button.textContent = message;
        window.setTimeout(function () {
          button.textContent = defaultText;
        }, 2200);
      }

      function fallbackCopy() {
        var textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.top = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();

        try {
          var copied = document.execCommand('copy');
          showStatus(copied ? successText : errorText);
        } catch (error) {
          showStatus(errorText);
        }

        document.body.removeChild(textarea);
      }

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(function () {
          showStatus(successText);
        }).catch(function () {
          fallbackCopy();
        });
      } else {
        fallbackCopy();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ov-customer-order"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-ov-copy-order-packet], [data-ov-copy-fedex-handoff-packet], [data-ov-copy-delivery-change-packet]');
    if (!button) {
      return;
    }

    var targetId = button.getAttribute('data-copy-target');
    var target = targetId ? document.getElementById(targetId) : null;
    var container = button.closest('.ov-customer-order__handoff-packet, .ov-customer-order__delivery-review');
    var status = container ? container.querySelector('[data-ov-copy-order-status], [data-ov-copy-delivery-change-status]') : null;
    var text = target ? target.textContent.trim() : '';

    if (!text) {
      return;
    }

    var defaultText = button.textContent.trim();
    var successText = button.getAttribute('data-copy-success') || defaultText;
    var errorText = button.getAttribute('data-copy-error') || defaultText;

    var showStatus = function(message) {
      if (status) {
        status.textContent = message;
      }
      button.textContent = message;
      window.setTimeout(function() {
        button.textContent = defaultText;
      }, 2200);
    };

    var fallbackCopy = function() {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.top = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        var copied = document.execCommand('copy');
        showStatus(copied ? successText : errorText);
      } catch (error) {
        showStatus(errorText);
      }

      document.body.removeChild(textarea);
    };

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(function() {
        showStatus(successText);
      }).catch(function() {
        fallbackCopy();
      });
    } else {
      fallbackCopy();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ov-legacy-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-support-endpoint]').forEach((form) => {
    if (form.dataset.supportBound === 'true') return;
    form.dataset.supportBound = 'true';

    const endpoint = form.dataset.supportEndpoint;
    const submitButton = form.querySelector('button[type="submit"]');
    const successMessage = form.querySelector('[data-support-success]');
    const errorMessage = form.querySelector('[data-support-error]');
    const errorText = form.querySelector('[data-support-error-text]');

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!endpoint) return;

      successMessage.hidden = true;
      errorMessage.hidden = true;
      if (submitButton) submitButton.disabled = true;

      const formData = new FormData(form);
      const payload = {
        phone: String(formData.get('phone') || ''),
        phoneCountryCode: String(formData.get('phoneCountryCode') || ''),
        productSupport: String(formData.get('productSupport') || ''),
        message: String(formData.get('message') || ''),
        website: String(formData.get('website') || ''),
        pageUrl: window.location.href,
        referrer: document.referrer,
      };

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });
        const result = await response.json().catch(() => null);
        if (!response.ok || !result || result.ok !== true) {
          throw new Error(result && result.error ? result.error : 'The message could not be sent.');
        }

        form.reset();
        successMessage.hidden = false;
        successMessage.focus();
      } catch (error) {
        errorText.textContent = error instanceof Error ? error.message : 'The message could not be sent.';
        errorMessage.hidden = false;
        errorMessage.focus();
      } finally {
        if (submitButton) submitButton.disabled = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
